import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderDecisionDigest from "../../../../src/content/decisiondigest/donationHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderDecisionDigest,
  React
};